/* Product page - Element Packaging, 7 October 2026.
   Works with snippets el-key-facts, el-product-price, autumn-sale-tiers and el-matching-lids.
   - Price block, case tile and multi-buy table follow the selected variant.
   - Multi-buy row highlight and nudge follow the form quantity plus qualifying cases already in the basket.
   - Multi-buy panel collapses on its header; the choice is remembered per visitor (localStorage).
   - Matching lid quick add and "Add both" post to /cart/add.js and refresh the header cart count.
   - The specification table replaces the plain "Specifications" tab text.
   Prices in Shopify are inc VAT; ex VAT = inc / 1.2 rounded to the penny. Keep 0.85 / 0.8075 in step with
   the automatic discounts (3+ cases 15%, 10+ cases 19.25%). */
(function () {
  'use strict';
  if (window.__elPdp) return;
  window.__elPdp = true;

  var R3 = 0.85, R10 = 0.8075;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function fmt(p) { return '£' + (p / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function exv(p) { return Math.round(p / 1.2); }
  function perPiece(ex, pcs) {
    if (!(pcs > 0)) return '';
    var m = Math.floor(ex * 10 / pcs);
    if (m < 1000) return '£0.' + ('00' + m).slice(-3);
    return '£' + (ex / pcs / 100).toFixed(2);
  }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function store(k, v) { try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (e) { return null; } }

  var details = $('.product-details[data-product-details]') || document;
  var form = $('.product-form--regular form[data-product-form]', details) ||
             $('form[action*="/cart/add"][data-product-form]') ||
             $('form[action*="/cart/add"]', details);
  var qtyInput = form ? form.querySelector('[name="quantity"]') : null;

  var outer = $('.product--outer');
  if (outer && $('[data-el-pdp]')) outer.classList.add('el-pdp-page');
  var sect = outer ? outer.closest('.shopify-section') : null;
  if (sect && $('[data-el-pdp]')) sect.classList.add('el-pdp-section');

  /* ---------- variant data ---------- */
  var vdata = { variants: {}, pcsDefault: 0 };
  try { var j = $('script[data-el-variants]'); if (j) vdata = JSON.parse(j.textContent); } catch (e) {}
  var currentId = vdata.selected ? String(vdata.selected) : null;

  function formVariantId() {
    if (!form) return currentId;
    var el = form.querySelector('[name="id"]');
    var v = el && el.value;
    return v && v !== 'not-selected' ? String(v) : currentId;
  }
  function variant() { return vdata.variants[currentId] || null; }
  function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }

  /* ---------- price block ---------- */
  function renderPrice() {
    var v = variant(); var box = $('[data-el-price]');
    if (!v || !box) return;
    var ex = exv(v.price);
    setText($('[data-el-ex]', box), fmt(ex));
    setText($('[data-el-inc]', box), fmt(v.price));
    var was = $('[data-el-was]', box);
    if (v.compare > v.price) { setText($('[data-el-was-amt]', box), fmt(exv(v.compare))); was.hidden = false; } else if (was) { was.hidden = true; }
    var st = $('[data-el-stock]', box);
    if (st) { setText(st, v.available ? 'In stock' : 'Out of stock'); st.classList.toggle('is-out', !v.available); }
    var pw = $('[data-el-pp-wrap]', box);
    if (pw) { var pp = perPiece(ex, v.pcs); pw.hidden = !pp; if (pp) setText($('[data-el-pp]', box), pp); }
    var facts = $('[data-el-facts]'); var cs = $('[data-el-case]');
    if (facts && cs && v.pcs > 0) {
      var t = String(v.pcs), inner = +facts.dataset.inner, ppi = +facts.dataset.ppi;
      if (inner > 1 && ppi > 0 && v.pcs === +facts.dataset.pcs) t += ' (' + inner + ' x ' + ppi + ')';
      setText(cs, t);
    }
  }

  /* ---------- multi-buy table ---------- */
  var mb = $('[data-el-mb]');
  var inCart = 0, inCart10 = 0;
  var tagCache = {};

  function renderTiers() {
    if (!mb) return;
    var v = variant();
    var p1 = v ? v.price : +mb.dataset.p1;
    var pcs = v && v.pcs ? v.pcs : +mb.dataset.pcs;
    var no10 = mb.dataset.no10 === 'true';
    var prices = { 1: p1, 3: Math.round(p1 * R3), 10: Math.round(p1 * R10) };
    $$('tr[data-min]', mb).forEach(function (r) {
      var p = prices[r.dataset.min], ex = exv(p);
      setText($('[data-el-t-ex]', r), fmt(ex));
      setText($('[data-el-t-inc]', r), fmt(p));
      setText($('[data-el-t-pp]', r), perPiece(ex, pcs) || '-');
    });
    setText($('[data-el-mb-from]', mb), fmt(exv(prices[3])));

    var n = qty(), t3 = n + inCart, t10 = n + inCart10;
    $$('tr[data-min]', mb).forEach(function (r) {
      var m = +r.dataset.min;
      var on = (m === 1 && t3 < 3) || (m === 3 && t3 >= 3 && (no10 || t10 < 10)) || (m === 10 && !no10 && t10 >= 10);
      r.classList.toggle('is-on', on);
      if (on) r.setAttribute('aria-current', 'true'); else r.removeAttribute('aria-current');
    });
    var txt = $('[data-el-mb-nudge]', mb), bar = $('[data-el-mb-bar]', mb);
    var pre = inCart > 0 ? 'With the ' + inCart + ' qualifying case' + (inCart > 1 ? 's' : '') + ' in your basket: ' : '';
    if (t3 < 3) {
      var need = 3 - t3;
      txt.innerHTML = (pre ? pre + 'add' : 'Add') + ' <b>' + need + ' more case' + (need > 1 ? 's' : '') + '</b> (any mix) to pay <b>' + fmt(exv(prices[3])) + ' a case</b> ex VAT.';
      bar.style.width = (t3 / 3 * 100) + '%';
    } else if (!no10 && t10 < 10) {
      txt.innerHTML = pre + (pre ? 'you' : 'You') + ' are paying <b>' + fmt(exv(prices[3])) + ' a case</b> ex VAT. Add <b>' + (10 - t10) + ' more</b> (any mix) for ' + fmt(exv(prices[10])) + '.';
      bar.style.width = (t10 / 10 * 100) + '%';
    } else {
      txt.innerHTML = pre + (pre ? 'you' : 'You') + ' are on the best price: <b>' + fmt(exv(no10 ? prices[3] : prices[10])) + ' a case</b> ex VAT.';
      bar.style.width = '100%';
    }
  }

  function countBasket() {
    if (!mb) return Promise.resolve();
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var a = 0, b = 0;
      return Promise.all((c.items || []).map(function (i) {
        var got = tagCache[i.handle] ? Promise.resolve(tagCache[i.handle]) :
          fetch('/products/' + i.handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
            tagCache[i.handle] = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
            return tagCache[i.handle];
          });
        return got.then(function (tags) {
          if (tags.indexOf('tier-pricing') > -1) { a += i.quantity; if (tags.indexOf('autumn-sale-no10') === -1) b += i.quantity; }
        }).catch(function () {});
      })).then(function () { inCart = a; inCart10 = b; renderTiers(); });
    }).catch(function () {});
  }

  if (mb) {
    var btn = $('[data-el-mb-toggle]', mb), body = $('[data-el-mb-body]', mb);
    var setOpen = function (open, save) {
      mb.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      body.hidden = !open;
      if (save) store('el-mb-open', open ? '1' : '0');
    };
    setOpen(store('el-mb-open') !== '0', false);
    btn.addEventListener('click', function () { setOpen(btn.getAttribute('aria-expanded') !== 'true', true); });
    $$('tr[data-min]', mb).forEach(function (r) {
      function pick() {
        if (qtyInput) { qtyInput.value = r.dataset.min; qtyInput.dispatchEvent(new Event('input', { bubbles: true })); qtyInput.dispatchEvent(new Event('change', { bubbles: true })); }
        renderAll();
      }
      r.addEventListener('click', pick);
      r.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
    });
  }

  /* ---------- matching lids ---------- */
  var lids = $('[data-el-lids]');
  function msg(t) { var m = $('[data-el-lids-msg]'); if (m) m.textContent = t || ''; }

  function refreshCartCount() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-header-cart-count]').forEach(function (el) {
        el.setAttribute('data-header-cart-count', c.item_count > 0 ? String(c.item_count) : '');
        el.classList.toggle('visible', c.item_count > 0);
      });
      try { document.dispatchEvent(new CustomEvent('el:cart-updated', { detail: c })); } catch (e) {}
      return c;
    }).then(function () { return countBasket(); }).catch(function () {});
  }

  function addItems(items, button, doneText) {
    var label = button.textContent;
    button.disabled = true; msg('');
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
      if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Could not add to basket');
      button.textContent = doneText; button.classList.add('is-done');
      refreshCartCount();
      setTimeout(function () { button.textContent = label; button.classList.remove('is-done'); button.disabled = false; }, 2500);
    }).catch(function (e) {
      button.disabled = false; msg(e.message || 'Could not add to basket - please try again.');
    });
  }

  function renderBoth() {
    var both = $('[data-el-both]'); if (!both) return;
    var v = variant(); var n = qty();
    if (!v || !both.dataset.lidId) { both.hidden = true; return; }
    both.hidden = false;
    var tot = (exv(v.price) + (+both.dataset.lidEx)) * n;
    var t = $('[data-el-both-text]', both);
    t.innerHTML = '';
    var b = document.createElement('b'); b.textContent = both.dataset.mainName + ' + ' + both.dataset.lidName; t.appendChild(b);
    t.appendChild(document.createTextNode(', ' + n + ' case' + (n > 1 ? 's' : '') + ' each: '));
    var p = document.createElement('b'); p.className = 'el-money'; p.textContent = fmt(tot); t.appendChild(p);
    t.appendChild(document.createTextNode(' ex VAT' + (n >= 2 ? ' before multi-buy' : '')));
    var bb = $('[data-el-both-btn]', both); if (bb && !bb.classList.contains('is-done')) bb.disabled = !v.available;
  }

  if (lids) {
    $$('[data-el-lid-row]', lids).forEach(function (row) {
      var inp = $('[data-el-step-input]', row);
      $$('[data-el-step]', row).forEach(function (b) {
        b.addEventListener('click', function () { inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.dataset.elStep, 10)); });
      });
      var add = $('[data-el-add]', row);
      add.addEventListener('click', function () {
        addItems([{ id: +add.dataset.elAdd, quantity: Math.max(1, parseInt(inp.value, 10) || 1) }], add, 'Added');
      });
    });
    var bothBtn = $('[data-el-both-btn]', lids);
    if (bothBtn) bothBtn.addEventListener('click', function () {
      var both = $('[data-el-both]'); var n = qty();
      addItems([{ id: +currentId, quantity: n }, { id: +both.dataset.lidId, quantity: n }], bothBtn, 'Added');
    });
  }

  /* ---------- specification table into the Specifications tab ---------- */
  var tpl = $('template[data-el-spec-tpl]');
  if (tpl && tpl.content && tpl.content.querySelector('tr')) {
    $$('.pxu-tabs .tab-label').forEach(function (l) {
      if (l.textContent.trim().toLowerCase() !== 'specifications') return;
      var panel = l.nextElementSibling;
      if (panel && panel.classList.contains('tab-panel')) { panel.innerHTML = ''; panel.appendChild(tpl.content.cloneNode(true)); }
    });
  }

  /* ---------- wiring ---------- */
  function renderAll() { renderPrice(); renderTiers(); renderBoth(); }
  var lastQty = null;
  function check() {
    var id = formVariantId();
    var q = qtyInput ? qtyInput.value : null;
    if ((id !== currentId && vdata.variants[id]) || q !== lastQty) {
      if (vdata.variants[id]) currentId = id;
      lastQty = q;
      renderAll();
    }
  }
  if (form) {
    ['change', 'input'].forEach(function (ev) { form.addEventListener(ev, function () { setTimeout(check, 0); }); });
    form.addEventListener('click', function () { setTimeout(check, 60); setTimeout(check, 300); });
    form.addEventListener('submit', function () { setTimeout(countBasket, 1500); setTimeout(countBasket, 4000); });
    var vs = form.querySelector('variant-selection, [data-variant-selection]');
    if (vs && window.MutationObserver) new MutationObserver(function () { setTimeout(check, 0); }).observe(vs, { attributes: true, attributeFilter: ['variant'] });
  }
  document.addEventListener('variant-change', function () { setTimeout(check, 0); });
  window.addEventListener('pageshow', function () { setTimeout(check, 0); });

  renderAll();
  countBasket();
})();
